'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002emath$002e$002dBig$002dInteger from "./java.math.-Big-Integer.js";
import * as $j_java$002emath$002e$002dConversion$0024 from "./java.math.-Conversion$.js";
import * as $j_java$002emath$002e$002dRounding$002dMode$0024 from "./java.math.-Rounding-Mode$.js";
var $p;
function $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1) {
  return $thiz.iG.a[diffScale$1];
}
export { $p_Ljava_math_BigDecimal$__powLen$1__I__I as $p_Ljava_math_BigDecimal$__powLen$1__I__I };
function $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1) {
  return ((augend$1.aI + $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1)) | 0);
}
export { $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I as $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I };
function $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I($thiz, thisValue$1, augend$1, diffScale$1) {
  var a = thisValue$1.aI;
  var b = $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1);
  return ((1 + ((a > b) ? a : b)) | 0);
}
export { $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I as $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I };
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.vg = null;
  this.zF = null;
  this.zH = null;
  this.dg = null;
  this.iG = null;
  this.IP = null;
  this.zG = null;
  this.lP = null;
  $n_Ljava_math_BigDecimal$ = this;
  this.vg = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  this.zF = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.zH = this.PH(28, 5);
  var len = ((this.zH.a.length >>> 1) | 0);
  var result = new $j_java$002elang$002e$002dObject.$ac_I(len);
  var i = 0;
  while ((i < len)) {
    var value = i;
    var $x_4 = $m_Ljava_math_BigDecimal$();
    var $x_2 = $m_Ljava_math_BigDecimal$().zH.a;
    var $x_3 = (value << 1);
    var $x_1_$_lo = $x_2[$x_3];
    var $x_1_$_hi = $x_2[(($x_3 + 1) | 0)];
    result.a[value] = $x_4.Bb($x_1_$_lo, $x_1_$_hi);
    i = ((1 + i) | 0);
  }
  this.dg = this.PH(19, 10);
  var len$2 = ((this.dg.a.length >>> 1) | 0);
  var result$2 = new $j_java$002elang$002e$002dObject.$ac_I(len$2);
  var i$1 = 0;
  while ((i$1 < len$2)) {
    var value$1 = i$1;
    var $x_8 = $m_Ljava_math_BigDecimal$();
    var $x_6 = $m_Ljava_math_BigDecimal$().dg.a;
    var $x_7 = (value$1 << 1);
    var $x_5_$_lo = $x_6[$x_7];
    var $x_5_$_hi = $x_6[(($x_7 + 1) | 0)];
    result$2.a[value$1] = $x_8.Bb($x_5_$_lo, $x_5_$_hi);
    i$1 = ((1 + i$1) | 0);
  }
  this.iG = result$2;
  var result$3 = new ($d_Ljava_math_BigDecimal.r().C)(11);
  var i$2 = 0;
  while ((i$2 < 11)) {
    var value$2 = i$2;
    result$3.a[value$2] = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), value$2, 0);
    i$2 = ((1 + i$2) | 0);
  }
  this.IP = result$3;
  var result$4 = new ($d_Ljava_math_BigDecimal.r().C)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var value$3 = i$3;
    result$4.a[value$3] = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, value$3);
    i$3 = ((1 + i$3) | 0);
  }
  this.zG = result$4;
  this.lP = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
}
export { $c_Ljava_math_BigDecimal$ as $c_Ljava_math_BigDecimal$ };
$p = $c_Ljava_math_BigDecimal$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
}
export { $h_Ljava_math_BigDecimal$ as $h_Ljava_math_BigDecimal$ };
$h_Ljava_math_BigDecimal$.prototype = $p;
$p.fp = (function(unscaledVal_$_lo, unscaledVal_$_hi, scale) {
  return ((scale === 0) ? this.rs(unscaledVal_$_lo, unscaledVal_$_hi) : (((((unscaledVal_$_lo | unscaledVal_$_hi) === 0) && (scale >= 0)) && (scale < this.zG.a.length)) ? this.zG.a[scale] : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal_$_lo, unscaledVal_$_hi, scale)));
});
$p.rs = (function(unscaledVal_$_lo, unscaledVal_$_hi) {
  return (((unscaledVal_$_hi >= 0) && ((unscaledVal_$_hi === 0) ? ((unscaledVal_$_lo >>> 0) < 11) : (unscaledVal_$_hi < 0))) ? this.IP.a[unscaledVal_$_lo] : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal_$_lo, unscaledVal_$_hi, 0));
});
$p.Pp = (function(thisValue, augend, diffScale) {
  if (((diffScale < ((this.dg.a.length >>> 1) | 0)) && ($p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I(this, thisValue, augend, diffScale) < 64))) {
    var x_$_lo = augend.al;
    var x_$_hi = augend.am;
    var $x_1 = this.dg.a;
    var $x_2 = (diffScale << 1);
    var x$1_$_lo = $x_1[$x_2];
    var x$1_$_hi = $x_1[(($x_2 + 1) | 0)];
    var a0 = (65535 & x_$_lo);
    var a1 = ((x_$_lo >>> 16) | 0);
    var b0 = (65535 & x$1_$_lo);
    var b1 = ((x$1_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var x$2_$_lo = thisValue.al;
    var x$2_$_hi = thisValue.am;
    var lo$1 = ((x$2_$_lo + lo) | 0);
    var hi$1 = ((((x$2_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
    return this.fp(lo$1, hi$1, thisValue.ab);
  } else {
    var $x_4 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
    var $x_3 = augend.b8();
    var hi$2 = (diffScale >> 31);
    var bi = $x_4.l4($x_3, diffScale, hi$2);
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Elementary$().ji(thisValue.b8(), bi), thisValue.ab);
  }
});
$p.Pq = (function(scaledDividend, scaledDivisor, scale, roundingMode) {
  var qr = scaledDividend.Bl(scaledDivisor);
  if ((qr.lR.a3 === 0)) {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), qr.hD, scale);
  } else {
    var sign = Math.imul(scaledDividend.a3, scaledDivisor.a3);
    var parityBit = (qr.hD.ya(0) | 0);
    if (($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BitLevel$().kO(scaledDivisor) < 63)) {
      var $x_1 = qr.lR.gB();
      var rem_$_lo = $x_1.l;
      var rem_$_hi = $x_1.h;
      var $x_2 = scaledDivisor.gB();
      var divisor_$_lo = $x_2.l;
      var divisor_$_hi = $x_2.h;
      var sign$1 = (rem_$_hi >> 31);
      var xlo = (rem_$_lo ^ sign$1);
      var rlo = ((xlo - sign$1) | 0);
      var rhi = (((rem_$_hi ^ sign$1) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var lo = (rlo << 1);
      var hi = (((rlo >>> 31) | 0) | (rhi << 1));
      var sign$2 = (divisor_$_hi >> 31);
      var xlo$1 = (divisor_$_lo ^ sign$2);
      var rlo$1 = ((xlo$1 - sign$2) | 0);
      var rhi$1 = (((divisor_$_hi ^ sign$2) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
      var compRem$3 = this.BT(parityBit, Math.imul(sign, ((5 + this.Pr(lo, hi, rlo$1, rhi$1)) | 0)), roundingMode);
    } else {
      var compRem$3 = this.BT(parityBit, Math.imul(sign, ((5 + qr.lR.NO().XC().jl(scaledDivisor.NO())) | 0)), roundingMode);
    }
    if ((compRem$3 !== 0)) {
      if (($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BitLevel$().kO(qr.hD) < 63)) {
        var $x_3 = qr.hD.gB();
        var x_$_lo = $x_3.l;
        var x_$_hi = $x_3.h;
        var hi$1 = (compRem$3 >> 31);
        var lo$1 = ((x_$_lo + compRem$3) | 0);
        var hi$2 = ((((x_$_hi + hi$1) | 0) + (((lo$1 >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
        return this.fp(lo$1, hi$2, scale);
      } else {
        var $x_6 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Elementary$();
        var $x_5 = qr.hD;
        var $x_4 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$();
        var hi$3 = (compRem$3 >> 31);
        return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_6.ji($x_5, $x_4.ed(compRem$3, hi$3)), scale);
      }
    } else {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), qr.hD, scale);
    }
  }
});
$p.xw = (function(scaledDividend_$_lo, scaledDividend_$_hi, scaledDivisor_$_lo, scaledDivisor_$_hi, scale, roundingMode) {
  var $x_1 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(scaledDividend_$_lo, scaledDividend_$_hi, scaledDivisor_$_lo, scaledDivisor_$_hi);
  var q_$_lo = $x_1.l;
  var q_$_hi = $x_1.h;
  var a0 = (65535 & scaledDivisor_$_lo);
  var a1 = ((scaledDivisor_$_lo >>> 16) | 0);
  var b0 = (65535 & q_$_lo);
  var b1 = ((q_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(scaledDivisor_$_lo, q_$_hi) + Math.imul(scaledDivisor_$_hi, q_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$1 = ((scaledDividend_$_lo - lo) | 0);
  var hi$1 = ((((scaledDividend_$_hi - hi) | 0) - (((lo$1 >>> 0) > (scaledDividend_$_lo >>> 0)) | 0)) | 0);
  var lo$2 = (scaledDividend_$_hi >> 31);
  var lo$3 = ((-scaledDividend_$_lo) | 0);
  var lo$6 = (scaledDivisor_$_hi >> 31);
  var lo$7 = ((-scaledDivisor_$_lo) | 0);
  var sign = Math.imul((lo$2 | ((((((-scaledDividend_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0) >>> 31) | 0)), (lo$6 | ((((((-scaledDivisor_$_hi) | 0) - ((lo$7 !== 0) | 0)) | 0) >>> 31) | 0)));
  if (((lo$1 | hi$1) !== 0)) {
    var sign$1 = (hi$1 >> 31);
    var xlo = (lo$1 ^ sign$1);
    var rlo = ((xlo - sign$1) | 0);
    var rhi = (((hi$1 ^ sign$1) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var lo$10 = (rlo << 1);
    var hi$6 = (((rlo >>> 31) | 0) | (rhi << 1));
    var sign$2 = (scaledDivisor_$_hi >> 31);
    var xlo$1 = (scaledDivisor_$_lo ^ sign$2);
    var rlo$1 = ((xlo$1 - sign$2) | 0);
    var rhi$1 = (((scaledDivisor_$_hi ^ sign$2) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var compRem = this.Pr(lo$10, hi$6, rlo$1, rhi$1);
    var value = this.BT((1 & q_$_lo), Math.imul(sign, ((5 + compRem) | 0)), roundingMode);
    var hi$7 = (value >> 31);
    var lo$11 = ((q_$_lo + value) | 0);
    var hi$8 = ((((q_$_hi + hi$7) | 0) + (((lo$11 >>> 0) < (q_$_lo >>> 0)) | 0)) | 0);
    var $x_2_$_lo = lo$11;
    var $x_2_$_hi = hi$8;
  } else {
    var $x_2_$_lo = q_$_lo;
    var $x_2_$_hi = q_$_hi;
  }
  return this.fp($x_2_$_lo, $x_2_$_hi, scale);
});
$p.Pr = (function(value1_$_lo, value1_$_hi, value2_$_lo, value2_$_hi) {
  return (((value1_$_hi === value2_$_hi) ? ((value1_$_lo >>> 0) > (value2_$_lo >>> 0)) : (value1_$_hi > value2_$_hi)) ? 1 : (((value1_$_hi === value2_$_hi) ? ((value1_$_lo >>> 0) < (value2_$_lo >>> 0)) : (value1_$_hi < value2_$_hi)) ? (-1) : 0));
});
$p.PH = (function(len, pow) {
  var result = new $j_java$002elang$002e$002dObject.$ac_J(len);
  var $x_1 = result.a;
  $x_1[0] = 1;
  $x_1[1] = 0;
  var i = 1;
  while ((i < len)) {
    var value = i;
    var $x_2 = result.a;
    var $x_3 = (((value - 1) | 0) << 1);
    var x_$_lo = $x_2[$x_3];
    var x_$_hi = $x_2[(($x_3 + 1) | 0)];
    var hi = (pow >> 31);
    var a0 = (65535 & x_$_lo);
    var a1 = ((x_$_lo >>> 16) | 0);
    var b0 = (65535 & pow);
    var b1 = ((pow >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(x_$_lo, hi) + Math.imul(x_$_hi, pow)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var $x_4 = result.a;
    var $x_5 = (value << 1);
    $x_4[$x_5] = lo;
    $x_4[(($x_5 + 1) | 0)] = hi$1;
    i = ((1 + i) | 0);
  }
  return result;
});
$p.BT = (function(parityBit, fraction, roundingMode) {
  var sign = (fraction >> 31);
  var absFraction = (((fraction ^ sign) - sign) | 0);
  var sigFraction = ((fraction >> 31) | ((((-fraction) | 0) >>> 31) | 0));
  var x = $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().IZ;
  if (((x === null) ? (roundingMode === null) : (x === roundingMode))) {
    return sigFraction;
  } else {
    var x$3 = $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().IU;
    if (((x$3 === null) ? (roundingMode === null) : (x$3 === roundingMode))) {
      return 0;
    } else {
      var x$5 = $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().IT;
      if (((x$5 === null) ? (roundingMode === null) : (x$5 === roundingMode))) {
        return ((sigFraction > 0) ? sigFraction : 0);
      } else {
        var x$7 = $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().rX;
        if (((x$7 === null) ? (roundingMode === null) : (x$7 === roundingMode))) {
          return ((sigFraction < 0) ? sigFraction : 0);
        } else {
          var x$9 = $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().IX;
          if (((x$9 === null) ? (roundingMode === null) : (x$9 === roundingMode))) {
            return ((absFraction >= 5) ? sigFraction : 0);
          } else {
            var x$11 = $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().IV;
            if (((x$11 === null) ? (roundingMode === null) : (x$11 === roundingMode))) {
              return ((absFraction > 5) ? sigFraction : 0);
            } else {
              var x$13 = $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().IW;
              if (((x$13 === null) ? (roundingMode === null) : (x$13 === roundingMode))) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0);
              } else {
                var x$15 = $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().IY;
                if ((!((x$15 === null) ? (roundingMode === null) : (x$15 === roundingMode)))) {
                  throw new $j_java$002elang$002e$002dObject.$c_jl_AssertionError(roundingMode);
                }
                if ((fraction !== 0)) {
                  throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("Rounding necessary");
                }
                return 0;
              }
            }
          }
        }
      }
    }
  }
});
$p.l0 = (function(longValue_$_lo, longValue_$_hi) {
  if ((((longValue_$_hi === (-1)) ? ((longValue_$_lo >>> 0) < 2147483648) : (longValue_$_hi < (-1))) || ((longValue_$_hi === 0) ? ((longValue_$_lo >>> 0) > 2147483647) : (longValue_$_hi > 0)))) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException(("Out of int range: " + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(longValue_$_lo, longValue_$_hi)));
  }
  return longValue_$_lo;
});
$p.Ps = (function(longScale_$_lo, longScale_$_hi) {
  var hi = (longScale_$_lo >> 31);
  if ((((longScale_$_lo ^ longScale_$_lo) | (longScale_$_hi ^ hi)) === 0)) {
    return this.fp(0, 0, longScale_$_lo);
  } else {
    return ((longScale_$_hi >= 0) ? $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647) : $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648)));
  }
});
$p.Bb = (function(sValue_$_lo, sValue_$_hi) {
  if ((sValue_$_hi < 0)) {
    var lo = (~sValue_$_lo);
    var hi = (~sValue_$_hi);
    var smallValue_$_lo = lo;
    var smallValue_$_hi = hi;
  } else {
    var smallValue_$_lo = sValue_$_lo;
    var smallValue_$_hi = sValue_$_hi;
  }
  return ((64 - ((smallValue_$_hi !== 0) ? Math.clz32(smallValue_$_hi) : ((32 + Math.clz32(smallValue_$_lo)) | 0))) | 0);
});
$p.VC = (function(sValue) {
  return ((32 - Math.clz32(((sValue < 0) ? (~sValue) : sValue))) | 0);
});
var $d_Ljava_math_BigDecimal$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_BigDecimal$, "java.math.BigDecimal$", ({
  kx: 1,
  a: 1
}));
export { $d_Ljava_math_BigDecimal$ as $d_Ljava_math_BigDecimal$ };
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$();
  }
  return $n_Ljava_math_BigDecimal$;
}
export { $m_Ljava_math_BigDecimal$ as $m_Ljava_math_BigDecimal$ };
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.aI === 0)) {
    var x_$_lo = $thiz.al;
    var x_$_hi = $thiz.am;
    return (((~x_$_lo) | (~x_$_hi)) !== 0);
  } else {
    return false;
  }
}
export { $p_Ljava_math_BigDecimal__isZero__Z as $p_Ljava_math_BigDecimal__isZero__Z };
function $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal($thiz, newScale_$_lo, newScale_$_hi) {
  if ($p_Ljava_math_BigDecimal__isZero__Z($thiz)) {
    var $x_2 = $m_Ljava_math_BigDecimal$();
    if (((newScale_$_hi === 0) ? (newScale_$_lo !== 0) : (newScale_$_hi > 0))) {
      var $x_1_$_lo = newScale_$_lo;
      var $x_1_$_hi = newScale_$_hi;
    } else {
      var $x_1_$_lo = 0;
      var $x_1_$_hi = 0;
    }
    return $x_2.Ps($x_1_$_lo, $x_1_$_hi);
  } else if ((newScale_$_hi >= 0)) {
    return (($thiz.aI < 64) ? $m_Ljava_math_BigDecimal$().fp($thiz.al, $thiz.am, $m_Ljava_math_BigDecimal$().l0(newScale_$_lo, newScale_$_hi)) : $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $thiz.b8(), $m_Ljava_math_BigDecimal$().l0(newScale_$_lo, newScale_$_hi)));
  } else {
    var lo = ((-newScale_$_lo) | 0);
    var hi = ((((-newScale_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    var value = (($m_Ljava_math_BigDecimal$().dg.a.length >>> 1) | 0);
    var hi$1 = (value >> 31);
    if ((((hi === hi$1) ? ((lo >>> 0) < (value >>> 0)) : (hi < hi$1)) && ((($thiz.aI + $ps_Ljava_math_BigDecimal__lptbLen$1__J__I(newScale_$_lo, newScale_$_hi)) | 0) < 64))) {
      var $x_5 = $m_Ljava_math_BigDecimal$();
      var x_$_lo = $thiz.al;
      var x_$_hi = $thiz.am;
      var $x_3 = $m_Ljava_math_BigDecimal$().dg.a;
      var $x_4 = (((-newScale_$_lo) | 0) << 1);
      var x$1_$_lo = $x_3[$x_4];
      var x$1_$_hi = $x_3[(($x_4 + 1) | 0)];
      var a0 = (65535 & x_$_lo);
      var a1 = ((x_$_lo >>> 16) | 0);
      var b0 = (65535 & x$1_$_lo);
      var b1 = ((x$1_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $x_5.fp(lo$1, hi$2, 0);
    } else {
      var $x_8 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
      var $x_7 = $thiz.b8();
      var $x_6 = $m_Ljava_math_BigDecimal$();
      var lo$2 = ((-newScale_$_lo) | 0);
      var hi$3 = ((((-newScale_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
      var value$1 = $x_6.l0(lo$2, hi$3);
      var hi$4 = (value$1 >> 31);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_8.l4($x_7, value$1, hi$4), 0);
    }
  }
}
export { $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal as $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal };
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.ab;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
  if (((hi$3 === 0) ? ((lo$1 >>> 0) > 19) : (hi$3 > 0))) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("Rounding necessary");
  }
  var bigInteger = $thiz.Y4();
  if (($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BitLevel$().kO(bigInteger) < bitLengthOfType)) {
    return bigInteger.gB();
  } else {
    throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("Rounding necessary");
  }
}
export { $p_Ljava_math_BigDecimal__valueExact__I__J as $p_Ljava_math_BigDecimal__valueExact__I__J };
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.zE > 0) ? $thiz.zE : ((1 + $j_java$002elang$002e$002dObject.$doubleToInt((0.3010299956639812 * (($thiz.aI - 1) | 0)))) | 0));
}
export { $p_Ljava_math_BigDecimal__approxPrecision__I as $p_Ljava_math_BigDecimal__approxPrecision__I };
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.jR = unscaledVal;
  $thiz.aI = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BitLevel$().kO(unscaledVal);
  if (($thiz.aI < 64)) {
    var $x_1 = unscaledVal.gB();
    $thiz.al = $x_1.l;
    $thiz.am = $x_1.h;
  }
}
export { $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V as $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V };
function $ps_Ljava_math_BigDecimal__powTenLen$1__I__I(diffScale$2) {
  return $m_Ljava_math_BigDecimal$().iG.a[diffScale$2];
}
export { $ps_Ljava_math_BigDecimal__powTenLen$1__I__I as $ps_Ljava_math_BigDecimal__powTenLen$1__I__I };
function $p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I($thiz, subtrahend$1, diffScale$2) {
  var a = $thiz.aI;
  var b = ((subtrahend$1.aI + $ps_Ljava_math_BigDecimal__powTenLen$1__I__I(diffScale$2)) | 0);
  return ((1 + ((a > b) ? a : b)) | 0);
}
export { $p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I as $p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I };
function $ps_Ljava_math_BigDecimal__powTenLen$2__I__I(negDiffScale$1) {
  return $m_Ljava_math_BigDecimal$().iG.a[negDiffScale$1];
}
export { $ps_Ljava_math_BigDecimal__powTenLen$2__I__I as $ps_Ljava_math_BigDecimal__powTenLen$2__I__I };
function $p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I($thiz, subtrahend$1, negDiffScale$1) {
  var a = (($thiz.aI + $ps_Ljava_math_BigDecimal__powTenLen$2__I__I(negDiffScale$1)) | 0);
  var b = subtrahend$1.aI;
  return ((1 + ((a > b) ? a : b)) | 0);
}
export { $p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I as $p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I };
function $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal($thiz, divisor$1, diffScale$3, scale$1, roundingMode$1) {
  var scaledDividend0 = $thiz.b8();
  var scaledDivisor0 = divisor$1.b8();
  if ((diffScale$3 > 0)) {
    var $x_1 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
    var hi = (diffScale$3 >> 31);
    var x1___1 = scaledDividend0;
    var x1___2 = $x_1.l4(scaledDivisor0, diffScale$3, hi);
  } else if ((diffScale$3 < 0)) {
    var $x_2 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
    var value = ((-diffScale$3) | 0);
    var hi$1 = (value >> 31);
    var x1___1 = $x_2.l4(scaledDividend0, value, hi$1);
    var x1___2 = scaledDivisor0;
  } else {
    var x1___1 = scaledDividend0;
    var x1___2 = scaledDivisor0;
  }
  var scaledDividend = x1___1;
  var scaledDivisor = x1___2;
  return $m_Ljava_math_BigDecimal$().Pq(scaledDividend, scaledDivisor, scale$1, roundingMode$1);
}
export { $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal as $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal };
function $p_Ljava_math_BigDecimal__cmp$1__J__I($thiz, diffScale$6_$_lo, diffScale$6_$_hi) {
  return (($thiz.aI + $m_Ljava_math_BigDecimal$().iG.a[diffScale$6_$_lo]) | 0);
}
export { $p_Ljava_math_BigDecimal__cmp$1__J__I as $p_Ljava_math_BigDecimal__cmp$1__J__I };
function $ps_Ljava_math_BigDecimal__lptbLen$1__J__I(newScale$2_$_lo, newScale$2_$_hi) {
  return $m_Ljava_math_BigDecimal$().iG.a[((-newScale$2_$_lo) | 0)];
}
export { $ps_Ljava_math_BigDecimal__lptbLen$1__J__I as $ps_Ljava_math_BigDecimal__lptbLen$1__J__I };
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.jS = null;
  $thiz.g6 = 0;
  $thiz.aI = 0;
  $thiz.al = 0;
  $thiz.am = 0;
  $thiz.ab = 0;
  $thiz.zE = 0;
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__ as $ct_Ljava_math_BigDecimal__ };
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue_$_lo, smallValue_$_hi, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.al = smallValue_$_lo;
  $thiz.am = smallValue_$_hi;
  $thiz.ab = scale;
  $thiz.aI = $m_Ljava_math_BigDecimal$().Bb(smallValue_$_lo, smallValue_$_hi);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__J__I__ as $ct_Ljava_math_BigDecimal__J__I__ };
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.al = smallValue;
  $thiz.am = hi;
  $thiz.ab = scale;
  $thiz.aI = $m_Ljava_math_BigDecimal$().VC(smallValue);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__I__I__ as $ct_Ljava_math_BigDecimal__I__I__ };
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.ab = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__ as $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__ };
function $ct_Ljava_math_BigDecimal__I__($thiz, iVal) {
  $ct_Ljava_math_BigDecimal__I__I__($thiz, iVal, 0);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__I__ as $ct_Ljava_math_BigDecimal__I__ };
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.jS = null;
  this.g6 = 0;
  this.jR = null;
  this.aI = 0;
  this.al = 0;
  this.am = 0;
  this.ab = 0;
  this.zE = 0;
}
export { $c_Ljava_math_BigDecimal as $c_Ljava_math_BigDecimal };
$p = $c_Ljava_math_BigDecimal.prototype = new $j_java$002elang$002e$002dObject.$h_jl_Number();
$p.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
}
export { $h_Ljava_math_BigDecimal as $h_Ljava_math_BigDecimal };
$h_Ljava_math_BigDecimal.prototype = $p;
$p.B2 = (function(augend) {
  var diffScale = ((this.ab - augend.ab) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return augend;
  } else if (($p_Ljava_math_BigDecimal__isZero__Z(augend) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this;
  } else if ((diffScale === 0)) {
    var a = this.aI;
    var b = augend.aI;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $x_1 = $m_Ljava_math_BigDecimal$();
      var x_$_lo = this.al;
      var x_$_hi = this.am;
      var x$1_$_lo = augend.al;
      var x$1_$_hi = augend.am;
      var lo = ((x_$_lo + x$1_$_lo) | 0);
      var hi = ((((x_$_hi + x$1_$_hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
      return $x_1.fp(lo, hi, this.ab);
    } else {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Elementary$().ji(this.b8(), augend.b8()), this.ab);
    }
  } else {
    return ((diffScale > 0) ? $m_Ljava_math_BigDecimal$().Pp(this, augend, diffScale) : $m_Ljava_math_BigDecimal$().Pp(augend, this, ((-diffScale) | 0)));
  }
});
$p.CE = (function(subtrahend) {
  var diffScale = ((this.ab - subtrahend.ab) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return subtrahend.We();
  } else if (($p_Ljava_math_BigDecimal__isZero__Z(subtrahend) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this;
  } else if ((diffScale === 0)) {
    var a = this.aI;
    var b = subtrahend.aI;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $x_1 = $m_Ljava_math_BigDecimal$();
      var x_$_lo = this.al;
      var x_$_hi = this.am;
      var x$1_$_lo = subtrahend.al;
      var x$1_$_hi = subtrahend.am;
      var lo = ((x_$_lo - x$1_$_lo) | 0);
      var hi = ((((x_$_hi - x$1_$_hi) | 0) - (((lo >>> 0) > (x_$_lo >>> 0)) | 0)) | 0);
      return $x_1.fp(lo, hi, this.ab);
    } else {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Elementary$().lg(this.b8(), subtrahend.b8()), this.ab);
    }
  } else if ((diffScale > 0)) {
    if (((diffScale < (($m_Ljava_math_BigDecimal$().dg.a.length >>> 1) | 0)) && ($p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I(this, subtrahend, diffScale) < 64))) {
      var $x_2 = $m_Ljava_math_BigDecimal$().dg.a;
      var $x_3 = (diffScale << 1);
      var powTen_$_lo = $x_2[$x_3];
      var powTen_$_hi = $x_2[(($x_3 + 1) | 0)];
      var $x_4 = $m_Ljava_math_BigDecimal$();
      var x$3_$_lo = this.al;
      var x$3_$_hi = this.am;
      var x$2_$_lo = subtrahend.al;
      var x$2_$_hi = subtrahend.am;
      var a0 = (65535 & x$2_$_lo);
      var a1 = ((x$2_$_lo >>> 16) | 0);
      var b0 = (65535 & powTen_$_lo);
      var b1 = ((powTen_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((((((((Math.imul(x$2_$_lo, powTen_$_hi) + Math.imul(x$2_$_hi, powTen_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((x$3_$_lo - lo$1) | 0);
      var hi$2 = ((((x$3_$_hi - hi$1) | 0) - (((lo$2 >>> 0) > (x$3_$_lo >>> 0)) | 0)) | 0);
      return $x_4.fp(lo$2, hi$2, this.ab);
    } else {
      var $x_6 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
      var $x_5 = subtrahend.b8();
      var hi$3 = (diffScale >> 31);
      var mult = $x_6.l4($x_5, diffScale, hi$3);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Elementary$().lg(this.b8(), mult), this.ab);
    }
  } else {
    var negDiffScale = ((-diffScale) | 0);
    if (((negDiffScale < (($m_Ljava_math_BigDecimal$().dg.a.length >>> 1) | 0)) && ($p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I(this, subtrahend, negDiffScale) < 64))) {
      var $x_7 = $m_Ljava_math_BigDecimal$().dg.a;
      var $x_8 = (negDiffScale << 1);
      var powTen$2_$_lo = $x_7[$x_8];
      var powTen$2_$_hi = $x_7[(($x_8 + 1) | 0)];
      var $x_9 = $m_Ljava_math_BigDecimal$();
      var x$4_$_lo = this.al;
      var x$4_$_hi = this.am;
      var a0$1 = (65535 & x$4_$_lo);
      var a1$1 = ((x$4_$_lo >>> 16) | 0);
      var b0$1 = (65535 & powTen$2_$_lo);
      var b1$1 = ((powTen$2_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(a0$1, b0$1);
      var a1b0$1 = Math.imul(a1$1, b0$1);
      var a0b1$1 = Math.imul(a0$1, b1$1);
      var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$4 = ((((((((Math.imul(x$4_$_lo, powTen$2_$_hi) + Math.imul(x$4_$_hi, powTen$2_$_lo)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var x$5_$_lo = subtrahend.al;
      var x$5_$_hi = subtrahend.am;
      var lo$4 = ((lo$3 - x$5_$_lo) | 0);
      var hi$5 = ((((hi$4 - x$5_$_hi) | 0) - (((lo$4 >>> 0) > (lo$3 >>> 0)) | 0)) | 0);
      return $x_9.fp(lo$4, hi$5, subtrahend.ab);
    } else {
      var $x_12 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Elementary$();
      var $x_11 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
      var $x_10 = this.b8();
      var hi$6 = (negDiffScale >> 31);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_12.lg($x_11.l4($x_10, negDiffScale, hi$6), subtrahend.b8()), subtrahend.ab);
    }
  }
});
$p.W9 = (function(multiplicand) {
  var value = this.ab;
  var hi = (value >> 31);
  var value$1 = multiplicand.ab;
  var hi$1 = (value$1 >> 31);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + (((lo >>> 0) < (value >>> 0)) | 0)) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) || $p_Ljava_math_BigDecimal__isZero__Z(multiplicand))) {
    return $m_Ljava_math_BigDecimal$().Ps(lo, hi$2);
  } else if ((((this.aI + multiplicand.aI) | 0) < 64)) {
    var x_$_lo = this.al;
    var x_$_hi = this.am;
    var x$1_$_lo = multiplicand.al;
    var x$1_$_hi = multiplicand.am;
    var a0 = (65535 & x_$_lo);
    var a1 = ((x_$_lo >>> 16) | 0);
    var b0 = (65535 & x$1_$_lo);
    var b1 = ((x$1_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$3 = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    if (((lo$1 | ((-2147483648) ^ hi$3)) === 0)) {
      var x$2_$_lo = this.al;
      var x$2_$_hi = this.am;
      var $x_2 = (x$2_$_hi < 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3_$_lo = multiplicand.al;
      var x$3_$_hi = multiplicand.am;
      var $x_1 = (x$3_$_hi < 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().Pa(63), $m_Ljava_math_BigDecimal$().l0(lo, hi$2));
    } else {
      return $m_Ljava_math_BigDecimal$().fp(lo$1, hi$3, $m_Ljava_math_BigDecimal$().l0(lo, hi$2));
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.b8().dv(multiplicand.b8()), $m_Ljava_math_BigDecimal$().l0(lo, hi$2));
  }
});
$p.TA = (function(divisor, scale, roundingMode) {
  if ($p_Ljava_math_BigDecimal__isZero__Z(divisor)) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("Division by zero");
  }
  var value = this.ab;
  var hi = (value >> 31);
  var value$1 = divisor.ab;
  var hi$1 = (value$1 >> 31);
  var lo = ((value - value$1) | 0);
  var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
  var hi$3 = (scale >> 31);
  var lo$1 = ((lo - scale) | 0);
  var hi$4 = ((((hi$2 - hi$3) | 0) - (((lo$1 >>> 0) > (lo >>> 0)) | 0)) | 0);
  if (((lo$1 >> 31) !== hi$4)) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException((("Unable to scale as difference is too big (" + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(lo$1, hi$4)) + ")"));
  }
  if (((this.aI < 64) && (divisor.aI < 64))) {
    var lptLen = (($m_Ljava_math_BigDecimal$().dg.a.length >>> 1) | 0);
    if ((lo$1 === 0)) {
      var div_$_lo = divisor.al;
      var div_$_hi = divisor.am;
      return $m_Ljava_math_BigDecimal$().xw(this.al, this.am, div_$_lo, div_$_hi, scale, roundingMode);
    } else if ((lo$1 > 0)) {
      if (((lo$1 < lptLen) && (((divisor.aI + $m_Ljava_math_BigDecimal$().iG.a[lo$1]) | 0) < 64))) {
        var x_$_lo = divisor.al;
        var x_$_hi = divisor.am;
        var $x_1 = $m_Ljava_math_BigDecimal$().dg.a;
        var $x_2 = (lo$1 << 1);
        var x$1_$_lo = $x_1[$x_2];
        var x$1_$_hi = $x_1[(($x_2 + 1) | 0)];
        var a0 = (65535 & x_$_lo);
        var a1 = ((x_$_lo >>> 16) | 0);
        var b0 = (65535 & x$1_$_lo);
        var b1 = ((x$1_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$6 = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        return $m_Ljava_math_BigDecimal$().xw(this.al, this.am, lo$2, hi$6, scale, roundingMode);
      } else {
        return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode);
      }
    } else if (((lo$1 > ((-lptLen) | 0)) && (((this.aI + $m_Ljava_math_BigDecimal$().iG.a[((-lo$1) | 0)]) | 0) < 64))) {
      var x$2_$_lo = this.al;
      var x$2_$_hi = this.am;
      var $x_3 = $m_Ljava_math_BigDecimal$().dg.a;
      var $x_4 = (((-lo$1) | 0) << 1);
      var x$3_$_lo = $x_3[$x_4];
      var x$3_$_hi = $x_3[(($x_4 + 1) | 0)];
      var a0$1 = (65535 & x$2_$_lo);
      var a1$1 = ((x$2_$_lo >>> 16) | 0);
      var b0$1 = (65535 & x$3_$_lo);
      var b1$1 = ((x$3_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(a0$1, b0$1);
      var a1b0$1 = Math.imul(a1$1, b0$1);
      var a0b1$1 = Math.imul(a0$1, b1$1);
      var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$7 = ((((((((Math.imul(x$2_$_lo, x$3_$_hi) + Math.imul(x$2_$_hi, x$3_$_lo)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      return $m_Ljava_math_BigDecimal$().xw(lo$3, hi$7, divisor.al, divisor.am, scale, roundingMode);
    } else {
      return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode);
    }
  } else {
    return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode);
  }
});
$p.We = (function() {
  if ((this.aI < 63)) {
    var $x_1 = true;
  } else if ((this.aI === 63)) {
    var x_$_lo = this.al;
    var x_$_hi = this.am;
    var $x_1 = ((x_$_lo | ((-2147483648) ^ x_$_hi)) !== 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var $x_2 = $m_Ljava_math_BigDecimal$();
    var x$1_$_lo = this.al;
    var x$1_$_hi = this.am;
    var lo = ((-x$1_$_lo) | 0);
    var hi = ((((-x$1_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    return $x_2.fp(lo, hi, this.ab);
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.b8().xI(), this.ab);
  }
});
$p.Cx = (function() {
  if ((this.aI < 64)) {
    var x_$_lo = this.al;
    var x_$_hi = this.am;
    if ((x_$_hi < 0)) {
      return (-1);
    } else {
      var x$1_$_lo = this.al;
      var x$1_$_hi = this.am;
      return (((x$1_$_hi === 0) ? (x$1_$_lo !== 0) : (x$1_$_hi > 0)) | 0);
    }
  } else {
    return this.b8().a3;
  }
});
$p.Qm = (function(newScale, roundingMode) {
  var hi = (newScale >> 31);
  var value = this.ab;
  var hi$1 = (value >> 31);
  var lo = ((newScale - value) | 0);
  var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (newScale >>> 0)) | 0)) | 0);
  if (((lo | hi$2) === 0)) {
    return this;
  } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
    var value$1 = (($m_Ljava_math_BigDecimal$().dg.a.length >>> 1) | 0);
    var hi$3 = (value$1 >> 31);
    if ((((hi$2 === hi$3) ? ((lo >>> 0) < (value$1 >>> 0)) : (hi$2 < hi$3)) && ($p_Ljava_math_BigDecimal__cmp$1__J__I(this, lo, hi$2) < 64))) {
      var $x_3 = $m_Ljava_math_BigDecimal$();
      var x_$_lo = this.al;
      var x_$_hi = this.am;
      var $x_1 = $m_Ljava_math_BigDecimal$().dg.a;
      var $x_2 = (lo << 1);
      var x$1_$_lo = $x_1[$x_2];
      var x$1_$_hi = $x_1[(($x_2 + 1) | 0)];
      var a0 = (65535 & x_$_lo);
      var a1 = ((x_$_lo >>> 16) | 0);
      var b0 = (65535 & x$1_$_lo);
      var b1 = ((x$1_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $x_3.fp(lo$1, hi$4, newScale);
    } else {
      var $x_5 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
      var $x_4 = this.b8();
      var hi$5 = (lo >> 31);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_5.l4($x_4, lo, hi$5), newScale);
    }
  } else {
    if ((this.aI < 64)) {
      var lo$2 = ((-lo) | 0);
      var hi$6 = ((((-hi$2) | 0) - ((lo$2 !== 0) | 0)) | 0);
      var value$2 = (($m_Ljava_math_BigDecimal$().dg.a.length >>> 1) | 0);
      var hi$7 = (value$2 >> 31);
      var $x_6 = ((hi$6 === hi$7) ? ((lo$2 >>> 0) < (value$2 >>> 0)) : (hi$6 < hi$7));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var $x_7 = $m_Ljava_math_BigDecimal$().dg.a;
      var $x_8 = (((-lo) | 0) << 1);
      var lpt_$_lo = $x_7[$x_8];
      var lpt_$_hi = $x_7[(($x_8 + 1) | 0)];
      return $m_Ljava_math_BigDecimal$().xw(this.al, this.am, lpt_$_lo, lpt_$_hi, newScale, roundingMode);
    } else {
      var $x_9 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
      var lo$3 = ((-lo) | 0);
      var hi$8 = ((((-hi$2) | 0) - ((lo$3 !== 0) | 0)) | 0);
      var powTen = $x_9.rf(lo$3, hi$8);
      return $m_Ljava_math_BigDecimal$().Pq(this.b8(), powTen, newScale, roundingMode);
    }
  }
});
$p.W7 = (function(n) {
  var value = this.ab;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value + n) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + (((lo >>> 0) < (value >>> 0)) | 0)) | 0);
  return $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal(this, lo, hi$2);
});
$p.XQ = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return $m_Ljava_math_BigDecimal$().vg;
  } else {
    var lastPow = (($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$().iJ.a.length - 1) | 0);
    var i = 1;
    var strippedBI = this.b8();
    var value = this.ab;
    var hi = (value >> 31);
    var scale_$_lo = value;
    var scale_$_hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!strippedBI.ya(0))) {
        var qr = strippedBI.Bl($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$().iJ.a[i]);
        if ((qr.lR.a3 === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = qr.hD;
          var x_$_lo = scale_$_lo;
          var x_$_hi = scale_$_hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var lo = ((x_$_lo - value$1) | 0);
          var hi$2 = ((((x_$_hi - hi$1) | 0) - (((lo >>> 0) > (x_$_lo >>> 0)) | 0)) | 0);
          i = temp$i;
          strippedBI = temp$strippedBI;
          scale_$_lo = lo;
          scale_$_hi = hi$2;
          continue;
        }
        if ((i !== 1)) {
          i = 1;
          continue;
        }
        var x1___1 = strippedBI;
        var x1___2 = $j_java$002elang$002e$002dObject.$bL(scale_$_lo, scale_$_hi);
        break;
      } else {
        var x1___1 = strippedBI;
        var x1___2 = $j_java$002elang$002e$002dObject.$bL(scale_$_lo, scale_$_hi);
        break;
      }
    }
    var strippedBI$1 = x1___1;
    var $x_1 = $j_java$002elang$002e$002dObject.$uJ(x1___2);
    var newScale_$_lo = $x_1.l;
    var newScale_$_hi = $x_1.h;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().l0(newScale_$_lo, newScale_$_hi));
  }
});
$p.Ol = (function(bi) {
  var thisSign = this.Cx();
  var valueSign = bi.Cx();
  if ((thisSign === valueSign)) {
    if ((((this.ab === bi.ab) && (this.aI < 64)) && (bi.aI < 64))) {
      var x_$_lo = this.al;
      var x_$_hi = this.am;
      var x$1_$_lo = bi.al;
      var x$1_$_hi = bi.am;
      if (((x_$_hi === x$1_$_hi) ? ((x_$_lo >>> 0) < (x$1_$_lo >>> 0)) : (x_$_hi < x$1_$_hi))) {
        return (-1);
      } else {
        var x$2_$_lo = this.al;
        var x$2_$_hi = this.am;
        var x$3_$_lo = bi.al;
        var x$3_$_hi = bi.am;
        return (((x$2_$_hi === x$3_$_hi) ? ((x$2_$_lo >>> 0) > (x$3_$_lo >>> 0)) : (x$2_$_hi > x$3_$_hi)) | 0);
      }
    } else {
      var value = this.ab;
      var hi = (value >> 31);
      var value$1 = bi.ab;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I(bi)) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((hi$2 + ((lo$1 === 0) | 0)) | 0);
      if (((hi$3 === hi$4) ? ((diffPrecision >>> 0) > (lo$1 >>> 0)) : (hi$3 > hi$4))) {
        return thisSign;
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = ((lo - 1) | 0);
        var hi$6 = ((((hi$2 - 1) | 0) + ((lo$2 !== (-1)) | 0)) | 0);
        if (((hi$5 === hi$6) ? ((diffPrecision >>> 0) < (lo$2 >>> 0)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0);
        } else {
          var t = this.b8();
          var v = bi.b8();
          if ((hi$2 < 0)) {
            var $x_1 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((((-hi$2) | 0) - ((lo$3 !== 0) | 0)) | 0);
            var x1___1 = t.dv($x_1.rf(lo$3, hi$7));
            var x1___2 = v;
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var x1___1 = t;
            var x1___2 = v.dv($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$().rf(lo, hi$2));
          } else {
            var x1___1 = t;
            var x1___2 = v;
          }
          var thisUnscaled = x1___1;
          var valUnscaled = x1___2;
          return thisUnscaled.jl(valUnscaled);
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1);
  }
});
$p.f = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    if ((x.ab === this.ab)) {
      if ((this.aI < 64)) {
        var $x_1 = x;
        var x$1_$_lo = $x_1.al;
        var x$1_$_hi = $x_1.am;
        var x$2_$_lo = this.al;
        var x$2_$_hi = this.am;
        return (((x$1_$_lo ^ x$2_$_lo) | (x$1_$_hi ^ x$2_$_hi)) === 0);
      } else {
        return this.jR.f(x.jR);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  if ((this.g6 !== 0)) {
    return this.g6;
  } else if ((this.aI < 64)) {
    this.g6 = $j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I(this.al, this.am);
    var $x_1 = this.g6;
    var x$1_$_lo = this.al;
    var x$1_$_hi = this.am;
    this.g6 = ((Math.imul(33, $x_1) + x$1_$_hi) | 0);
    this.g6 = ((Math.imul(17, this.g6) + this.ab) | 0);
    return this.g6;
  } else {
    this.g6 = ((Math.imul(17, this.jR.m()) + this.ab) | 0);
    return this.g6;
  }
});
$p.b = (function() {
  if ((this.jS !== null)) {
    return this.jS;
  } else if ((this.aI < 32)) {
    this.jS = $j_java$002emath$002e$002dConversion$0024.$m_Ljava_math_Conversion$().Y6(this.al, this.am, this.ab);
    return this.jS;
  } else {
    var intString = $j_java$002emath$002e$002dConversion$0024.$m_Ljava_math_Conversion$().rp(this.b8());
    if ((this.ab === 0)) {
      return intString;
    } else {
      var begin = ((this.b8().a3 < 0) ? 2 : 1);
      var end = intString.length;
      var value = this.ab;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((hi$3 - hi$4) | 0) - (((lo$2 >>> 0) > (lo$1 >>> 0)) | 0)) | 0);
      if (((this.ab > 0) && ((hi$5 === (-1)) ? ((lo$2 >>> 0) >= 4294967290) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.ab) | 0);
          $m_Ljava_math_BigDecimal$();
          var result = ((intString.substring(0, pos) + ".") + intString.substring(pos));
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = ((begin - 1) | 0);
          $m_Ljava_math_BigDecimal$();
          var s = ((intString.substring(0, pos$1) + "0.") + intString.substring(pos$1));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().lP;
          var s2Len = (~lo$2);
          $m_Ljava_math_BigDecimal$();
          var s2$1 = s2.substring(0, s2Len);
          var result = ((("" + s.substring(0, pos$2)) + s2$1) + s.substring(pos$2));
        }
      } else {
        var r0 = ((((end - begin) | 0) >= 1) ? ($m_Ljava_math_BigDecimal$(), $m_Ljava_math_BigDecimal$(), ((intString.substring(0, begin) + ".") + intString.substring(begin))) : intString);
        var r1 = (r0 + "E");
        var result = ((((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1) + $j_java$002elang$002e$002dObject.$m_RTLong$().jv(lo$2, hi$5));
      }
      this.jS = result;
      return this.jS;
    }
  }
});
$p.Yb = (function() {
  var intStr = $j_java$002emath$002e$002dConversion$0024.$m_Ljava_math_Conversion$().rp(this.b8());
  if (((this.ab === 0) || ($p_Ljava_math_BigDecimal__isZero__Z(this) && (this.ab < 0)))) {
    return intStr;
  } else {
    var begin = ((this.Cx() < 0) | 0);
    var delta = this.ab;
    var result = ((begin === 1) ? "-" : "");
    if ((this.ab > 0)) {
      delta = ((delta - ((intStr.length - begin) | 0)) | 0);
      if ((delta >= 0)) {
        result = (result + "0.");
        while ((delta > 100)) {
          result = (("" + result) + $m_Ljava_math_BigDecimal$().lP);
          delta = ((delta - 100) | 0);
        }
        var $x_1 = result;
        var this$2 = $m_Ljava_math_BigDecimal$().lP;
        var endIndex = delta;
        result = ((("" + $x_1) + this$2.substring(0, endIndex)) + intStr.substring(begin));
      } else {
        delta = ((begin - delta) | 0);
        var $x_3 = result;
        var endIndex$1 = delta;
        var $x_2 = intStr.substring(begin, endIndex$1);
        var beginIndex = delta;
        result = (($x_3 + ($x_2 + ".")) + intStr.substring(beginIndex));
      }
    } else {
      result = (("" + result) + intStr.substring(begin));
      while ((delta < (-100))) {
        result = (("" + result) + $m_Ljava_math_BigDecimal$().lP);
        delta = ((100 + delta) | 0);
      }
      var $x_4 = result;
      var this$11 = $m_Ljava_math_BigDecimal$().lP;
      var endIndex$2 = ((-delta) | 0);
      result = (("" + $x_4) + this$11.substring(0, endIndex$2));
    }
    return result;
  }
});
$p.Y4 = (function() {
  if (((this.ab === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.b8();
  } else if ((this.ab < 0)) {
    var $x_2 = this.b8();
    var $x_1 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
    var value = this.ab;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
    return $x_2.dv($x_1.rf(lo, hi$1));
  } else {
    if (((this.ab > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.ab > this.b8().P8()))) {
      throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("Rounding necessary");
    }
    var $x_4 = this.b8();
    var $x_3 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Multiplication$();
    var value$1 = this.ab;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $x_4.TC($x_3.rf(value$1, hi$2));
    if ((integerAndFraction.a[1].a3 !== 0)) {
      throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("Rounding necessary");
    }
    return integerAndFraction.a[0];
  }
});
$p.b8 = (function() {
  if ((this.jR === null)) {
    this.jR = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().ed(this.al, this.am);
  }
  return this.jR;
});
$p.fh = (function(o) {
  return this.Ol(o);
});
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dt)));
}
export { $isArrayOf_Ljava_math_BigDecimal as $isArrayOf_Ljava_math_BigDecimal };
var $d_Ljava_math_BigDecimal = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_BigDecimal, "java.math.BigDecimal", ({
  dt: 1,
  aA: 1,
  a: 1,
  j: 1
}));
export { $d_Ljava_math_BigDecimal as $d_Ljava_math_BigDecimal };
